var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner",class:{ 'spinner--bg': _vm.bg }},[_c('Icon',{staticStyle:{"animation":"spin 1s infinite linear"},attrs:{"icon":"loading","h":_vm.size,"w":_vm.size,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }